import useSpecificSubjectContext from './context';
export default function useTranslations() {
    const ctx = useSpecificSubjectContext();
    if (!((ctx === null || ctx === void 0 ? void 0 : ctx.translations) instanceof Array)) {
        return null;
    }
    const { translations: [translations] } = ctx;
    return translations;
}
